/**
 * Het vlaggetje bij een land. Geen emoji: Windows toont van een vlag-emoji alleen de twee letters.
 * SVG's uit flag-icons (MIT), elk als eigen bestand (`no-inline`): de browser haalt alleen de vlaggen
 * op die er staan, en de JavaScript wordt er niet groter van.
 *
 * Versiering: de naam van het land staat er altijd naast, dus geen alt-tekst.
 */
const VLAGGEN = import.meta.glob('../../node_modules/flag-icons/flags/4x3/*.svg', { eager: true, query: '?url&no-inline', import: 'default' });
const PER_LAND = Object.fromEntries(Object.entries(VLAGGEN).map(([pad, url]) => [pad.match(/([a-z-]+)\.svg$/)[1], url]));

export default function Vlag({ cc }) {
  const url = cc && PER_LAND[String(cc).toLowerCase()];
  if (!url) return null;
  return <img className="vlag" src={url} alt="" width="16" height="12" loading="lazy" decoding="async" />;
}
